import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObject } from "@models/configurators/kb-object";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { Rule } from "@models/configurators/rule";
import { IReference, IRuleContainer } from "@models/entity-models";

@Kbo(CToken.RuleContainer)
export class RuleContainer extends KbObject implements IRuleContainer {
    constructor(kom: KbObjectManager, args?: { ruleType?: string}) {
        super(kom);
        if (args) {
            this.ruleType = args.ruleType;
        }
    }

    public ruleType: string;
    public js: string;

    private _rules: Rule[];
    @Enumerable()
    public get rules(): Rule[] {
        if (!this._rules) this._rules = [];
        return this._rules;
    }
    public set rules(val) {
        this._rules = val;
    }

    /**
     * holds the snap structure.  Starts with $ so angular will ignore it when parsing json
     */
    public $structure: any;

    // /**
    //  * the compiled rule, cached here for performance
    //  */
    // public $asyncFn: AsyncRuleFunction<any>;
    // public $syncFn: SyncRuleFunction<any>;

    public references: IReference[] = [];

    public removeRule(rule: Rule) {
        this.$manager.removeKbObject(rule);
        this.rules.removeWhere(r => r.id == rule.id);
    }

    // public serialize(): IRuleContainer {
    //     let o = super.serialize() as IRuleContainer;
    //     if (this.$structure) {
    //         o.js = (new snap.Js()).generate(this.$structure);
    //     }
    //     return o;
    // }
}
